/**
 * Surface component overrides: paper, accordion, app bar, containers, progress indicators.
 * @see https://mui.com/material-ui/components/paper/
 * @see https://mui.com/material-ui/components/accordion/
 * @see https://mui.com/material-ui/components/app-bar/
 * @see https://mui.com/material-ui/components/progress/
 */
import varnishTokens from '@allenai/varnish-theme/mui';
import type { Components, Theme } from '@mui/material';

export const surfaceComponents: Components<Omit<Theme, 'components'>> = {
    MuiAccordion: {
        styleOverrides: {
            root: ({ theme }) => ({
                backgroundColor: (theme.vars ?? theme).palette.elements.overlay.contentContrastHigh,
            }),
        },
    },
    MuiAccordionSummary: {
        styleOverrides: {
            root: { fontSize: varnishTokens.font.size.sm.value },
        },
    },
    MuiAppBar: {
        defaultProps: {
            color: 'default',
        },
        styleOverrides: {
            colorDefault: ({ theme }) => {
                const { palette } = theme.vars ?? theme;
                return {
                    backgroundColor: palette.background.reversed,
                    color: palette.text.reversed,
                };
            },
        },
    },
    MuiHeader: {
        defaultProps: {
            position: 'sticky',
            shape: 'box',
        },
    },
    MuiCircularProgress: {
        variants: [
            {
                props: { color: 'tertiary' },
                style: ({ theme }) => ({ color: (theme.vars ?? theme).palette.tertiary.main }),
            },
        ],
    },
    MuiContainer: {
        styleOverrides: {
            root: ({ theme }) => ({
                backgroundColor: (theme.vars ?? theme).palette.background.default,
            }),
        },
        defaultProps: {
            disableGutters: true,
        },
    },
    MuiLinearProgress: {
        variants: [
            {
                props: { color: 'tertiary' },
                style: ({ theme }) => ({ color: (theme.vars ?? theme).palette.tertiary.main }),
            },
        ],
    },
    MuiPaper: {
        defaultProps: {
            elevation: 0,
        },
    },
};
